
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductSizeMasterGrid extends Serenity.EntityGrid<ProductSizeMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ProductSizeMaster'; }
        protected getDialogType() { return ProductSizeMasterDialog; }
        protected getIdProperty() { return ProductSizeMasterRow.idProperty; }
        protected getInsertPermission() { return ProductSizeMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductSizeMasterRow.localTextPrefix; }
        protected getService() { return ProductSizeMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}